const loadingLabel = "Chargement";
const frBE = {
  loadingLabel
};
export {
  frBE as default,
  loadingLabel
};
